import type { DiagnosisData, ImportDealResponse } from "../types";

/**
 * Reconciles the full AI brief (which may arrive after the user already left
 * the diagnosis step) into the wizard's diagnosis state.
 *
 * Only ENRICHMENT fields are merged — narrative (if the user left "needs"
 * empty), insights and the full brief object that feeds the proposal payload
 * (soft preferences, cultural fit). Search-affecting fields (city, capacity,
 * budget, amenities) are deliberately NOT touched here: the user may have
 * already searched and selected spaces based on the current values, and
 * silently changing them would invalidate those choices.
 */
export function reconcileDiagnosisWithBrief(
  diagnosis: DiagnosisData,
  brief: ImportDealResponse,
): Partial<DiagnosisData> {
  const partial: Partial<DiagnosisData> = {
    importedData: brief,
    dealInsights: brief.deal_insights ?? [],
  };
  if (!diagnosis.needs?.trim() && brief.summary_narrative) {
    partial.needs = brief.summary_narrative;
  }
  // Deterministic HubSpot data, not user-editable — safe to always take when
  // present (the diagnosis form has no employees field to conflict with).
  if (brief.company_size != null) {
    partial.numberOfEmployees = brief.company_size;
  }
  return partial;
}
